import { Link } from "react-router-dom";

export default function Main() {
  return (
    // Text
    <div className="container text-center mt-5">
      <div className="row justify-content-start mb-4 mx-1">
        <div
          className="col-sm-12 col-lg-9 py-4 px-5 rounded-4 text-white bg-dark fs-5"
          style={{
            textShadow:
              "0 0 7px #3e0fe7, 0 0 10px #3e0fe7, 0 0 21px #3e0fe7, 0 0 42px #3e0fe7",
            boxShadow: "0 0 7px #3e0fe7, 0 0 10px #3e0fe7, 0 0 14px #3e0fe7",
          }}
        >
          <div className="row">
            <div className="col-12 col-md-1">
              <i className="bi bi-collection-play display-5"></i>
            </div>
            <div className="col-12 col-md-11">
              У програмуванні, як і в будь-якій іншій справі, практика є
              найважливішою складовою успіху. Ми спробували зібрати для Вас
              задачі, які допоможуть вивчати JavaScript на практиці.
            </div>
          </div>
        </div>
      </div>
      <div className="row justify-content-end mb-4 mx-1">
        <div
          className="col-sm-12 col-lg-9 py-4 px-5 rounded-4 text-white bg-dark fs-5"
          style={{
            textShadow:
              "0 0 7px #f92672, 0 0 10px #f92672, 0 0 21px #f92672, 0 0 42px #f92672",
            boxShadow: "0 0 7px #f92672, 0 0 10px #f92672, 0 0 14px #f92672",
          }}
        >
          <div className="row">
            <div className="col-12 col-md-1">
              <i className="bi bi-tags display-5"></i>
            </div>
            <div className="col-12 col-md-11">
              Ми намагаємось додавати задачі, які максимально наближені до
              реальних завдань, що можуть зустрітися в роботі. Деякі задачі
              спеціально створені для того, щоб продемонструвати можливості
              JavaScript, інші - щоб показати способи рішення типових завдань.
            </div>
          </div>
        </div>
      </div>
      <div className="row justify-content-start mb-4 mx-1">
        <div
          className="col-sm-12 col-lg-9 py-4 px-5 rounded-4 text-white bg-dark fs-5"
          style={{
            textShadow:
              "0 0 7px #5d8a03, 0 0 10px #5d8a03, 0 0 21px #5d8a03, 0 0 42px #5d8a03",
            boxShadow: "0 0 7px #5d8a03, 0 0 10px #5d8a03, 0 0 14px #5d8a03",
          }}
        >
          <div className="row">
            <div className="col-12 col-md-1">
              <i className="bi bi-award display-5"></i>
            </div>
            <div className="col-12 col-md-11">
              Очікується, що Ви вже пройшли хоча б один повний курс з основ
              JavaScript. Не важливо що це було: відеоуроки, безкоштовні, або
              платні онлайн курси, чи щось інше. Головне, щоб Ви були знайомі з
              базовим синтаксисом та конструкціями JavaScript.
            </div>
          </div>
        </div>
      </div>
      <div className="row justify-content-end mb-4 mx-1">
        <div
          className="col-sm-12 col-lg-9 py-4 px-5 rounded-4 text-white bg-dark fs-5"
          style={{
            textShadow:
              "0 0 7px #aa9902, 0 0 10px #aa9902, 0 0 21px #aa9902, 0 0 42px #aa9902",
            boxShadow: "0 0 7px #aa9902, 0 0 10px #aa9902, 0 0 14px #aa9902",
          }}
        >
          <div className="row">
            <div className="col-12 col-md-1">
              <i className="bi bi-layers display-5"></i>
            </div>
            <div className="col-12 col-md-11">
              Для розв'язання зібраних тут задач, Вам знадобиться терпіння, та
              базові знання з JavaScript. Всього іншого Ви навчитесь в процесі.
            </div>
          </div>
        </div>
      </div>
      <div className="row justify-content-start mb-4 mx-1">
        <div
          className="col-sm-12 col-lg-9 py-4 px-5 rounded-4 text-white bg-dark fs-5"
          style={{
            textShadow:
              "0 0 7px #945ef9, 0 0 10px #945ef9, 0 0 21px #945ef9, 0 0 42px #945ef9",
            boxShadow: "0 0 7px #945ef9, 0 0 10px #945ef9, 0 0 14px #945ef9",
          }}
        >
          <div className="row">
            <div className="col-12 col-md-1">
              <i className="bi bi-asterisk display-5"></i>
            </div>
            <div className="col-12 col-md-11">
              Буде корисним експериментувати з задачами. Спробуйте розв'язати
              кожну задачу декількома способами та проаналізуйте, який спосіб
              краще. Придумайте собі додаткові завдання, або умови до задач.
            </div>
          </div>
        </div>
      </div>
      <div className="row justify-content-end mb-4 mx-1">
        <div
          className="col-sm-12 col-lg-9 py-4 px-5 rounded-4 text-white bg-dark fs-5"
          style={{
            textShadow:
              "0 0 7px #09859e, 0 0 10px #09859e, 0 0 21px #09859e, 0 0 42px #09859e",
            boxShadow: "0 0 7px #09859e, 0 0 10px #09859e, 0 0 14px #09859e",
          }}
        >
          <div className="row">
            <div className="col-12 col-md-1">
              <i className="bi bi-capslock display-5"></i>
            </div>
            <div className="col-12 col-md-11">
              Не засмучуйтесь, якщо у Вас не виходить розв'язати задачу
              самостійно з першого разу. Після проходження всіх задач, спробуйте
              розв'язати їх ще раз. І повторюйте це до тих пір, доки вам не буде
              легко. Спробуйте досягти такого рівня, коли Ви зможете розв'язати
              за один день не менше 10-15 задач.
            </div>
          </div>
        </div>
      </div>
      <div className="row justify-content-start mb-4 mx-1">
        <div
          className="col-sm-12 col-lg-9 py-4 px-5 rounded-4 text-white bg-dark fs-5"
          style={{
            textShadow:
              "0 0 7px #c66c05, 0 0 10px #c66c05, 0 0 21px #c66c05, 0 0 42px #c66c05",
            boxShadow: "0 0 7px #c66c05, 0 0 10px #c66c05, 0 0 14px #c66c05",
          }}
        >
          <div className="row">
            <div className="col-12 col-md-1">
              <i className="bi bi-chat-left-text display-5"></i>
            </div>
            <div className="col-12 col-md-11">
              Якщо Ви помітили помилки в тексті або коді, хочете запропонувати
              нову задачу, або альтернативний спосіб розв'язання вже наявної
              задачі, можете краще сформулювати умову задачі - зверніться до{" "}
              <Link
                to="/Contacts"
                style={{
                  textDecoration: "underline",
                  color: "inherit",
                  cursor: "pointer",
                  fontWeight: "bold",
                }}
              >
                нас
              </Link>
              . Цим Ви дуже допоможете покращити сервіс.
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
